import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.48193 18.75L3.63118 20.3798C3.69868 21.1553 4.34743 21.75 5.12518 21.75H18.8742C19.6527 21.75 20.3014 21.1553 20.3689 20.3798L20.5182 18.75H3.48193Z" // eslint-disable-line
     }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 9L12 2.25L7.5 9L2.25 5.25L3.34575 17.25H20.6542L21.75 5.25L16.5 9Z" })), 'RankingFilled');
